import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from 'sonner';
import { useEffect } from 'react';

// Layout Components
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { WhatsAppButton } from './components/layout/WhatsAppButton';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

// Scroll to top on route change
const ScrollToTop = () => {
    const { pathname } = useLocation();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    
    return null;
};

// Layout wrapper for public pages
const PublicLayout = ({ children }) => {
    return (
        <>
            <Header />
            {children}
            <Footer />
            <WhatsAppButton />
        </>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Toaster 
                    position="top-right" 
                    richColors 
                    toastOptions={{
                        style: {
                            fontFamily: 'Inter, sans-serif',
                        },
                    }}
                />
                <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                    <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
                    <Route path="/services" element={<PublicLayout><ServicesPage /></PublicLayout>} />
                    <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
                    <Route path="/blog" element={<PublicLayout><BlogPage /></PublicLayout>} />
                    <Route path="/blog/:slug" element={<PublicLayout><BlogPostPage /></PublicLayout>} />
                    
                    {/* Admin Routes - No header/footer */}
                    <Route path="/admin" element={<AdminLogin />} />
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
